import { render } from "./workCenter.vue?vue&type=template&id=78295d93&scoped=true"
import script from "./workCenter.vue?vue&type=script&lang=js"
export * from "./workCenter.vue?vue&type=script&lang=js"

import "./workCenter.vue?vue&type=style&index=0&id=78295d93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78295d93"]])

export default __exports__